import _ from 'lodash'
import SelectScorecardForm from '../common/select-scorecard-form'

var AnnualMetricDataScorecardStep = SelectScorecardForm.extend({

	initialize: function(options) {
		var data = this.model.get('scorecardItem') || {}
		var opts = _.assign(options, {
			data: data,
			hideFollowLinked: true
		})

		SelectScorecardForm.prototype.initialize.call(this, opts)

		this.listenTo(this, 'item', function (item) {
			this.model.set('scorecardItem', item)
		}.bind(this))
	}

})

export default AnnualMetricDataScorecardStep

AnnualMetricDataScorecardStep.__filename__ = 'reports/wizard/annual-metric-data/annual-metric-data-scorecard.js'
